import React, { useCallback } from 'react'

import classnames from 'classnames'

import { ShowMore } from '../ShowMore'
import { SinglePadlockCta } from '../SinglePadlockCta'
import styles from './Table.module.scss'
import { formatTableChildren, mapScrollableTable } from './Table.utils'
import { getVariantSettings, variationTableRenderer } from './Variation/utils'

type Props = {
  className: string
  children: React.ReactNode
}

export const Table: React.FC<Props> = (props) => {
  return <TableRender {...props} />
}

const TableRender: React.FC<Props> = ({ className, children, ...props }) => {
  const tableNoScrolls = String(className).includes('non-scrollable')
  const formattedChildren = formatTableChildren(children)

  const variationSettings = getVariantSettings(formattedChildren)
  const hasVariation = !!variationSettings?.type

  const wrapTable = useCallback(
    () => (
      <div className={classnames(styles.tableWrapper, styles.tableControl)}>
        <div className={styles.scrollTableWrapper}>
          <table {...props}>{children}</table>
        </div>
        <span className={styles.tableBorder} />
      </div>
    ),
    [children, props]
  )
  const tableRenderer = tableNoScrolls ? wrapTable : mapScrollableTable
  const showMoreHandler = () => {
    const loadDynSquirrelEvent = new Event('LoadDynSquirrel', { bubbles: true, cancelable: true })

    document.dispatchEvent(loadDynSquirrelEvent)
  }

  return hasVariation ? (
    <>
      {variationTableRenderer({
        formattedChildren,
        variationSettings,
      })}
      <SinglePadlockCta />
    </>
  ) : (
    <ShowMore
      buttonLabel="Show all rows"
      contentRenderer={tableRenderer}
      callback={showMoreHandler}
      className={styles.showMoreWrapper}
    >
      {formattedChildren}
    </ShowMore>
  )
}
